import { useState } from 'react';
import LazyLoad from "react-lazyload";
import { Modal } from 'react-bootstrap';
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const VocationalClubPrimary = () => {
    const homeMenu = [
        { label: "MUN", link: "/Mun" },
        { label: "Glory to the Nation", link: "/GloryOfNation" },
        { label: "Spic Macay Cultural and Heritage Club", link: "/SpocmacyColtoralHeritage" },
        { label: "Vocational Education Clubs (Middle Wing) ", link: "/vocationalClubmiddle" },
        { label: "Vocational Education Clubs (Senior Wing)", link: "/vocationalClub" },
        { label: "Vocational Education Clubs (Primary Wing)", link: "/VocationalClubPrimary" },
    ];

    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState({ title: "", url: "" });

    const handleOpenModal = (title, url) => {
        setSelected({ title, url });
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/blog-banner.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle
                                pageTitle="Vocational Education Clubs (Primary Wing)"
                                breadEnd="Vocational Education Clubs"
                                breadMid="Vocational Education Clubs (Primary Wing)"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            <div
                                className="vocationalClub"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    handleOpenModal(
                                        "VOCATIONAL EDUCATION CLUBS - e-Brochure",
                                        "https://online.anyflip.com/sdtqz/dfpg/index.html"
                                    )
                                }
                            >
                                <LazyLoad>
                                    <img
                                        src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vocational-education-clubs.jpg"
                                        alt="VOCATIONAL EDUCATION CLUBS - e-Brochure"
                                        className="img-fluid"
                                    />
                                </LazyLoad>
                                <p>VOCATIONAL EDUCATION CLUBS - e-Brochure</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selected.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh' }}>
                    <iframe
                        src={selected.url}
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                        title={selected.title}
                    ></iframe>
                </Modal.Body>
            </Modal>

            <Footer />
        </>
    );
};

export default VocationalClubPrimary;
